  <p class="p-4 heading-4">
    <span data-dismiss="modal" aria-label="Close" class="cursor-pointer">
      <span aria-hidden="true">
        <img class="float-right"
           (click)="goBack()"
           src="assets/themes/icons/cancel.svg" 
           alt="cancel">
      </span>
    </span>
    <span class="color-grey-700">
      {{ mls.languageText.verification_country_and_association_screen.key1}}
    </span>
    <span *ngIf="mls?.is_lskey_display == 1">
      (verification_country_and_association_screen.key1)
    </span>
  </p>
  <div class="pl-4 pr-4 form-input pb-3">
    <div class="p-2 border input-field clearfix">
      <div class="float-left">
        <p>
          {{ mls.languageText.verification_country_and_association_screen.key2}}
          <span *ngIf="mls?.is_lskey_display == 1">
            (verification_country_and_association_screen.key2)</span>
        </p>
      </div>
      <div class="country-dropdown-input">
      <div class="float-right single-dropdown hide-cross drop-down" id="cntry-list-drop">
        <app-drop-down *ngIf="onboardingService.ddl_data.list_data.length > 0"
          (resetDDLData)="resetDDLData($event)" [DDLData]="onboardingService.ddl_data" [hasSelected]="hasSelected">
        </app-drop-down>
      </div>
    </div>
    </div>
  </div>
  <label class="secondary-paragraph pl-4" *ngIf="err_msg != ''"><span class="color-error">{{ err_msg }}</span></label>
  <div class="responsive-verify position-relative pl-3 pr-3 mr-1 ml-1 pt-1" [perfectScrollbar]="config">
    <p class="text-center" *ngIf="suggAssList?.length == 0">
      {{ mls.languageText.verification_country_and_association_screen.key3}}
      <span *ngIf="mls?.is_lskey_display == 1">
        (verification_country_and_association_screen.key3)</span>
    </p>
    <div class="clearfix secondary-paragraph" *ngFor="let assList of suggAssList; let idx = index"
      [ngClass]="{ 'mt-2': idx > 0 }">
      <label class=" d-block position-relative cursor-pointer clearfix">
        <div class="float-left mr-3">
          <img [src]="assList?.profile_pic_path" onerror="this.src='assets/themes/icons/association-placeholder.svg'" class="image-size post-pic rounded-circle" />
        </div>
        <div class="float-left w-75 mt-3">
          <p>{{ assList?.association_name }}</p>
        </div>
        <div class="checkbox float-right">
          <input type="checkbox" value="{{ assList?.association_id }}"
            [disabled]="assList?.is_verified == 1 || assList?.is_verified == '1' "
            (change)="selectValue($event, assList)" [checked]="makeSelected(assList?.association_id)" />
          <span class="mt-2"></span>
        </div>
      </label>
    </div>
  </div>
  <div class="p-4">
    <button class="btn-design medium w-100 input-height" [disabled]="showColor == false"
      [ngClass]="showColor ? 'filled cursor-pointer' : 'filled-disabled'" type="button" (click)="assignAssociation()">
      <span *ngIf="api_in_process == true" class="spinner-border spinner-border-sm" role="status"
        aria-hidden="true"></span>
      {{ mls.languageText.verification_country_and_association_screen.key4 }}
    </button>
  </div>